import { useEffect, useState } from "react";
import Sidebar from "components/Common/SideBar/SideBar";
import ObtInformationHeader from "components/Common/Header/Header";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import classes from "./Obtmgmt.module.css";
import CreateMilestones from "pages/MileStones/CreateMilestones";
import MileStones from "pages/MileStones/MileStones";
import Default from "components/Common/Default/Default";
import IDMCredentialTracking from "components/OBTIDMCredentialTracking/IDMCredentialTracking";
import IDMOGOwnerShip from "components/IDMOGOwnership/IDMOGOwnership";
import BulkEditIDMOGOwnerShip from "components/IDMOGOwnership/BulkEditIDMOGOwnership";
import OBTContactRoster from "components/OBTContactRoster/OBTContactRoster";
import OMTClassSchedule from "components/OMT/OMTClassSchedule/OMTClassSchedule";
import OMTClassSearch from "components/OMT/OMTClassSearch/OMTClassSearch";
import Overture from "components/OMT/Overture/Overture";
import { useAuth } from "context/AuthContext";
export default function OBTInfoManagement() {
  const { roles } = useAuth();

  const location = useLocation();
  const [index, setIndex] = useState(0);
  const [isASDGroupOnly, setIsASDGroupOnly] = useState(false);

  useEffect(() => {
    if (location.pathname === "/obtinfo") setIndex(0);

    if (location.pathname === "/obtinfo/accountOwnership") setIndex(1);

    if (location.pathname === "/obtinfo/contactRoster") setIndex(2);

    if (location.pathname === "/obtinfo/idmCredentialTracking") setIndex(3);

    if (location.pathname === "/obtinfo/createMilestones") setIndex(4);

    if (location.pathname === "/obtinfo/assignMilestones") setIndex(5);

    if (location.pathname === "/obtinfo/bulkEditAccountOwnerShip") setIndex(6);

    if (location.pathname === "/obtinfo/classSchedule") setIndex(7);
    if (location.pathname === "/obtinfo/classSearch") setIndex(8);
    if (location.pathname === "/obtinfo/overture") setIndex(9);
  }, [location.pathname]);

  useEffect(() => {
    const isOnlyASDGroup = roles.includes("ASD_Group") && roles.length === 1;
    setIsASDGroupOnly(isOnlyASDGroup);
  }, [roles]);

  return (
    <Grid container spacing={2} className={classes.obtMgmtBody}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={index} type="ObtMgmt" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        {index < 7 && !isASDGroupOnly ? (
          <ObtInformationHeader
            title="Onboarding Information"
            logoURL="/obtinfo"
            version="new"
          />
        ) : (
          <ObtInformationHeader
            title="Orientation Master Tracker"
            logoURL="/obtinfo"
            version="new"
          />
        )}
        <div className={classes.content}>
          {index === 0 && <Default />}
          {index === 1 && <IDMOGOwnerShip />}
          {index === 2 && <OBTContactRoster />}
          {index === 3 && <IDMCredentialTracking />}
          {index === 4 && <CreateMilestones />}
          {index === 5 && <MileStones />}
          {index === 6 && <BulkEditIDMOGOwnerShip />}
          {index === 7 && <OMTClassSchedule />}
          {index === 8 && <OMTClassSearch />}
          {index === 9 && <Overture />}
        </div>
      </Grid>
    </Grid>
  );
}
